export const landingPageConstants = {
  EMAIL_ACTIVATE_SUCCESS: "emailActivateSuccess",
  EMAIL_ACTIVATE_FAIL: "emailActivateFailure",
  USER_BLOCKED_TEMP: "userBlockedTemp",
  SIGNUP_SUCCESS:"signupSuccess",
  USER_VERIFICATION_FAIL: "userVerificationFailure",
  USER_ACCOUNT_DEACTIVATED: "userAccountDeactivated"
};
